export default __webpack_public_path__ + "locale/en/61cc6b79.json";